'use strict';

var spacer = require('../../../../../../../../../../_virtual/spacer.cjs');

var hasRequiredSpacer;

function requireSpacer () {
	if (hasRequiredSpacer) return spacer.__exports;
	hasRequiredSpacer = 1;

	var SpacerSizes = /*#__PURE__*/ function(SpacerSizes) {
	    SpacerSizes[SpacerSizes["quarter"] = 4] = "quarter";
	    SpacerSizes[SpacerSizes["half"] = 8] = "half";
	    SpacerSizes[SpacerSizes["one"] = 16] = "one";
	    SpacerSizes[SpacerSizes["oneQuarter"] = 20] = "oneQuarter";
	    SpacerSizes[SpacerSizes["oneHalf"] = 24] = "oneHalf";
	    SpacerSizes[SpacerSizes["double"] = 32] = "double";
	    SpacerSizes[SpacerSizes["doubleHalf"] = 40] = "doubleHalf";
	    SpacerSizes[SpacerSizes["triple"] = 48] = "triple";
	    SpacerSizes[SpacerSizes["tripleHalf"] = 56] = "tripleHalf";
	    SpacerSizes[SpacerSizes["quad"] = 64] = "quad";
	    return SpacerSizes;
	}({});

	spacer.__exports.SpacerSizes = SpacerSizes;
	
	return spacer.__exports;
}

exports.__require = requireSpacer;
//# sourceMappingURL=spacer.cjs.map
